import React, { FC, useState } from "react";
import { Button, Col, Input, Row } from "antd";

import { IModal } from "@types";
import Modal from "@components/Modal";
import { ErrorServices, useCreateCompanyJobFunctionMutation } from "@/services";
import { useTypedSelector } from "@/hooks";

const { TextArea } = Input;

const AddJobFunction: FC<IModal> = ({
  isVisible,
  setIsVisible,
  companyId = 1,
}) => {
  const { user } = useTypedSelector(state => state.auth);

  const [jobFunction, setJobFunction] = useState("");
  const [description, setDescription] = useState("");

  const [createCompanyJobFunction, { isLoading }] =
    useCreateCompanyJobFunctionMutation();

  const onSubmit = async () => {
    try {
      await createCompanyJobFunction({
        company_id: companyId,
        name: jobFunction,
        description,
      }).unwrap();

      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobFunction("");
    setDescription("");
  };

  return (
    <Modal
      width={544}
      onClose={closeModal}
      footer={[
        <Button
          disabled={!jobFunction.trim() || isLoading}
          onClick={onSubmit}
          key="1"
          type="primary"
          loading={isLoading}
        >
          Add
        </Button>,
        <Button onClick={closeModal} key="2">
          Cancel
        </Button>,
      ]}
      title="Add a Job Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Job Function</label>
            <Input
              value={jobFunction}
              onChange={e => setJobFunction(e.target.value)}
              size="large"
              placeholder="Name of the job function here..."
            />
          </Col>
        </Row>

        <Row
          justify="space-between"
          className="modal__row"
          style={{ marginTop: 16 }}
        >
          <Col span={24}>
            <label>Description</label>
            <TextArea
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
              placeholder="Description here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default AddJobFunction;
